export enum StripePaymentElementPaymentMethod {
  card = "card",
  afterpay_clearpay = "afterpay_clearpay",
  klarna = "klarna",
}
